import React, { useEffect } from 'react';
import { LiveVisitors } from './components/LiveVisitors';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { WhatYouGet } from './components/WhatYouGet';
import { ForWhom } from './components/ForWhom';
import { FAQSection } from './components/FAQSection';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { useMetaPixel } from './hooks/useMetaPixel';
import { ArrowDown } from 'lucide-react';
export function App() {
  useMetaPixel();
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-[#FDFBF7] font-sans text-gray-900 selection:bg-orange-200" data-id="element-0">
      {/* Sticky Header */}
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100 shadow-sm" data-id="element-1">
        <div className="max-w-5xl mx-auto flex items-center justify-between px-4 py-3" data-id="element-2">
          <span className="font-extrabold text-gray-900 text-lg md:text-xl tracking-tight" data-id="element-3">
            🍽️ Plato Mexicano <span className="text-[#2F855A]" data-id="element-4">Antipicos</span>
          </span>
          <button onClick={scrollToPricing} className="inline-flex items-center px-5 py-2.5 text-sm md:text-base font-bold text-white bg-[#2F855A] rounded-full hover:bg-[#276749] transition-all shadow-md hover:shadow-lg group" data-id="element-5">
            Quiero mi plan
            <ArrowDown className="ml-1.5 w-4 h-4 group-hover:translate-y-0.5 transition-transform" data-id="element-6" />
          </button>
        </div>
      </header>

      <LiveVisitors data-id="element-7" />

      <main data-id="element-8">
        <HeroSection data-id="element-9" />
        <PainSection data-id="element-10" />
        <SystemSection data-id="element-11" />
        <WhatYouGet data-id="element-12" />
        <ForWhom data-id="element-13" />
        <FAQSection data-id="element-14" />
        <PricingCTA data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
      <SocialProofPopup data-id="element-17" />
    </div>;
}